import styled from 'styled-components/native';

export default styled.View<{ noPadding?: boolean }>`
  background-color: ${({ theme }) => theme.colors.background};
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ noPadding }) => (noPadding ? 0 : '15px')};
`;
